import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
)

const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    autoTrackPageVisitTime: true,
    connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
    disableAjaxTracking: false,
    disableTelemetry: isLocalhost,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    extensionConfig: {},
    extensions: [reactPlugin],
  },
})
appInsights.loadAppInsights()

export { appInsights, reactPlugin }
